module.exports = "<div class=\"syncSettings__wrapper\">\n\t<uib-tabset>\n\t\t<uib-tab class=\"app__tab\" active=\"vm.createCustomerActive \" heading=\"Create Customer \" \n\t\tselect=\"vm.setActiveTabFromClick('createCustomer')\">\n\t\t\t<create-customer></create-customer>\n\t\t</uib-tab>\n\t\t</uib-tab>\n\t\t\t <uib-tab ng-if=\"vm.isSuperAdmin()\" class=\"app__tab\" active=\"vm.createAlertActive \" heading=\"Create Alert \" \n\t\tselect=\"vm.setActiveTabFromClick('createAlert')\">\n\t\t\t<add-alert-message></add-alert-message>\n\t\t</uib-tab>\n\t</uib-tabset>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/adminCreateSection/adminCreateSection.html
// module id = 548
// module chunks = 1